import React from 'react';
import { Link, withRouter } from "react-router-dom";

//layout
import Grid from '@material-ui/core/Grid'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import {withStyles} from '@material-ui/core/styles';
import CardPanel from '../Dashboard/CardPanel'

//services
import DatasetDynamicService from '../../services/DatasetDynamicService'

const useStyles = theme => ({
  root: {
    marginTop: 20,
  },
  paper: {
    padding: theme.spacing(2),      
    color: theme.palette.text.secondary,    
  }, 
});

class PivotModule extends React.Component {

  constructor(props){
    super(props);         
    this.refFlexmonster = React.createRef(); 
    this.state = {
      id: this.props.match.params.id,
      dataset:{},
      report:{},
      out: ""
    }
  }

  componentDidMount(prevProps) {  
      this.loadingAll()         
  }

  componentDidUpdate(prevProps) {  
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.loadingAll()      
    }
  }

  loadingAll = () => {
    const respDynData = DatasetDynamicService.searchById(this.props.match.params.id)
    respDynData.then((respDy)=>{         
        this.loadingData(respDy.data)
    })    
    .catch(error => console.error(error))
  }

  loadingData = (data) => {
    if(data.out === "flexmonster"){     
      this.loadingForFlexMonster(data)   
    } else if(data.out === "chartsHighcharts"){
      this.loadingForChartsHighcharts(data)      
    }
  }

  loadingForChartsHighcharts = (data) => {
    data.spaceWidth = 12
    data.spaceHeight = 1200

    this.setState({          
      dataset: data      
    })
  }

  loadingForFlexMonster = (data) => {
    this.setState({          
      dataset: data      
    })
  }

  render(){
    
    const { classes } = this.props;

    return (
      
      <div>
        
          <Grid item xs={12} >
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" to="/"  >
                <Home/>
              </Link>              
              <Typography color="textPrimary">{this.state.dataset.description}</Typography>
            </Breadcrumbs>
          </Grid>

          <Grid item xs={12} className={classes.root} >          
              {this.state.dataset?(<CardPanel dataset={this.state.dataset} />):('')}
          </Grid>

      </div>
    )
  }
}


export default withStyles(useStyles)(withRouter(PivotModule))